/* ============
 * Mutations for the formalities module
 * ============
 *
 * The mutations that are available on the
 * formalities module.
 */

export default {
  setMaxAmount (state, payload) {
    state.maxAmount = payload.data
  },
  clear (state) {
    state.maxAmount = null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/endorsements/mutations.js